import { render, staticRenderFns } from "./unload-content-cargo.vue?vue&type=template&id=d27c3330"
import script from "./unload-content-cargo.vue?vue&type=script&lang=js"
export * from "./unload-content-cargo.vue?vue&type=script&lang=js"
import style0 from "./unload-content-cargo.vue?vue&type=style&index=0&id=d27c3330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports